import { ProductPackageKind } from '@modules/product-package/models'
import { useAppData } from '@components/hooks/use-app-data'
import { useLocation } from 'react-router-dom'
import { useProductsAppData } from '@modules/products/hooks/use-products-app-data'
import { filterProductPackageSets, getProductPackageOffer, ProductPackageOffer } from './pms-offer'
import { ProductPackageSet } from '@models/products'

interface Response {
  listUrl: string
  offer: ProductPackageOffer | undefined
  productPackageSets: ProductPackageSet[]
}

export const useProductPackages = (kind: ProductPackageKind): Response => {
  const { urls } = useAppData()
  const { pathname, search } = useLocation()
  const { product_package_sets } = useProductsAppData()
  const offer = getProductPackageOffer(pathname, search)

  return {
    listUrl: urls.product_packages.product_package_list.replace('replace-me', kind),
    offer,
    productPackageSets: filterProductPackageSets(product_package_sets, kind, offer),
  }
}
